export class ContactRequest {
  fullName!: string;
  email!: string;
  contactReason?: string;
  phoneNumber?: string | number;
  message!: string;
  locale!: string;
}